/** Feature flags from CRA env (REACT_APP_*). */

export function isEmergentAuthEnabled() {
    return process.env.REACT_APP_ENABLE_EMERGENT_AUTH === "true";
}

export function isVisualEditsEnabled() {
    return process.env.REACT_APP_ENABLE_VISUAL_EDITS === "true";
}
